import { defineComponent as _defineComponent } from 'vue'
import { useImage } from '@/shared/composables/image'
import BKImage from '@/components/AppShared/BKImage.vue'
import { IEvent } from '@/enitites/event'
import { EventMapDB } from '@/enitites/map'
import EventCompactCard from '@/shared/ui/cards/EventCompactCard.vue'
import { getDateFormatted } from '@/services/date'

interface IProps {
  event: IEvent | EventMapDB
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EventPreviewCompactCard',
  props: {
    event: null
  },
  setup(__props: any) {

const props = __props as {
  event: IEvent | EventMapDB
};

const { getImageById } = useImage()


const srcImg = getImageById(props.event.image, 190, 190, 'event')

return { __sfc: true,getImageById, props, srcImg, BKImage, EventCompactCard, getDateFormatted }
}

})